import React from 'react';
import '../constants/AssetsCss';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

class ConvertWallet extends React.Component {
    constructor(props) {
        super(props);
        this.amountChanged = this.amountChanged.bind(this);
        this.convertWallet = this.convertWallet.bind(this);
        this.handleKeypress = this.handleKeypress.bind(this);
        this.state = {
            amount: ""
        }
    }
    amountChanged(event) {
        this.setState({ amount: event.target.value });
    }
    componentDidMount() {
        this.getDashboardDetails();
    }
    handleKeypress(e) {
        //it triggers by pressing the enter key
        if (e.key === "Enter") {
            this.convertWallet();
        }
    };
    async convertWallet() {
        if (!this.state.amount) {
            toast("Enter a amount");
            return;
        }
        let json = {
            walletamount: this.state.amount
        }
        let res = await GetORPostAsync("ConvertWalletConfirm.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        toast(res.message);
        let thisvar = this;
        swal("Please enter the login password", {
            content: "input",
            dangerMode: true,
            buttons: true,
        }).then((value) => {
            if (!value)
                return;
            let jsonstr = {
                walletamount: thisvar.state.amount,
                tac: value,
                tpassword:value
            };
            this.convertWalletConfirm(JSON.stringify(jsonstr));
        });
    }
    async convertWalletConfirm(json) {
        let res = await GetORPostAsync("ConvertWallet.asp", "POST", json, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }

            if (res.message === "TAC Error. Try Again") {
                let thisvar = this;
                swal("Please enter the login password", {
                    content: "input",
                    dangerMode: true,
                    buttons: true,
                }).then((value) => {
                    if (!value)
                        return;
                    let jsonstr = {
                        walletamount: thisvar.state.amount,
                        tac: value,
                        tpassword:value
                    };
                    this.convertWalletConfirm(JSON.stringify(jsonstr));
                });
            }
            return;
        }
        toast(res.message);
        this.getDashboardDetails();
    }
    async getDashboardDetails() {
        let res = await GetORPostAsync("GetDashboardDetails.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        this.setState(res);
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Bonus Statement</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Convert Wallet</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Convert Payout Wallet to Activation Wallet</h3>

                            <hr></hr>
                            <div className='col-lg-8 border-color-1' style={{border:'1px solid',borderRadius:"10px",padding:"10px 20px"}}>
                                <div class="row row-cols-1 row-cols-md-2 row-cols-xl-2 mb-2">
                                    <div class="d-flex align-items-center p-2">
                                        <div>
                                            <p class="mb-0 text-white">Activation Wallet Balance</p>
                                            <h4 class="my-1">{this.state.availablecompanywallet}</h4>
                                        </div>
                                        <div class="widgets-icons-2 bg-gradient-moonlit text-white ml-auto">
                                            <svg className="side-menu__icon" style={{ fill: 'white' }} xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 16 16" width="16"><path d="M0 0h16v16H0V0z" fill="none" /><path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                                <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z" /></svg>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center p-2">
                                        <div>
                                            <p class="mb-0 text-white">Payout Wallet Balance</p>
                                            <h4 class="my-1">{this.state.availablePaywallet}</h4>
                                        </div>
                                        <div class="widgets-icons-2 bg-gradient-ibiza text-white ml-auto">
                                            <svg className="side-menu__icon" style={{ fill: 'white' }} xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 16 16" width="16"><path d="M0 0h16v16H0V0z" fill="none" /><path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                                <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z" /></svg>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3 mt-5"><label for="amounttowithdraw" class="form-label">Amount to convert</label><input type="text" class="form-control" placeholder="Convert amount" onKeyPress={this.handleKeypress} value={this.state.amount} onChange={this.amountChanged} /></div>
                                <div class="mb-3 mt-5">
                                    <div class="d-grid"><button onClick={this.convertWallet} type="submit" class="btn btn-primary w-100">Convert</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default  withRouter(ConvertWallet);